/* eslint-disable */
import React, { useRef, useEffect } from "react";

export function ParticlesCanvas({ color = '212,175,116', count = 55, maxAlpha = 0.35, connectionDistance = 120, style }) {
  const canvasRef = useRef(null);

  useEffect(() => {
    const cvs = canvasRef.current;
    if (!cvs) return;
    const ctx = cvs.getContext('2d');
    let raf, pts = [];

    const resize = () => {
      cvs.width = window.innerWidth;
      cvs.height = window.innerHeight;
      init();
    };

    const init = () => {
      pts = [];
      for (let i = 0; i < count; i++) {
        pts.push({
          x: Math.random() * cvs.width,
          y: Math.random() * cvs.height,
          vx: (Math.random() - 0.5) * 0.3,
          vy: (Math.random() - 0.5) * 0.3,
          sz: Math.random() * 1.5 + 0.5,
          a: Math.random() * maxAlpha + 0.05,
        });
      }
    };

    const draw = () => {
      ctx.clearRect(0, 0, cvs.width, cvs.height);
      pts.forEach(p => {
        p.x += p.vx; p.y += p.vy;
        if (p.x < 0) p.x = cvs.width;
        if (p.x > cvs.width) p.x = 0;
        if (p.y < 0) p.y = cvs.height;
        if (p.y > cvs.height) p.y = 0;
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.sz, 0, Math.PI * 2);
        ctx.fillStyle = `rgba(${color},${p.a})`;
        ctx.fill();
      });
      for (let i = 0; i < pts.length; i++) {
        for (let j = i + 1; j < pts.length; j++) {
          const dx = pts[i].x - pts[j].x, dy = pts[i].y - pts[j].y;
          const d = Math.sqrt(dx * dx + dy * dy);
          if (d < connectionDistance) {
            ctx.beginPath();
            ctx.moveTo(pts[i].x, pts[i].y);
            ctx.lineTo(pts[j].x, pts[j].y);
            ctx.strokeStyle = `rgba(${color},${0.05 * (1 - d / connectionDistance)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        }
      }
      raf = requestAnimationFrame(draw);
    };

    resize();
    draw();
    window.addEventListener('resize', resize);
    return () => { cancelAnimationFrame(raf); window.removeEventListener('resize', resize); };
  }, [color, count, maxAlpha, connectionDistance]);

  return <canvas ref={canvasRef} style={{ position: 'fixed', inset: 0, zIndex: 'var(--z-base)', pointerEvents: 'none', ...style }} />;
}
